import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-payment',
  templateUrl: 'payment.html',
})
export class Payment {

  client: any;
  event: any;
  dataPay: any;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.dataPay = this.params.get('dataPay');
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-catalogs-payment/payment/payment.ts